<template>
  <div>
    <div class="topBox"></div>
    <div class="mark">
      <img src="@/assets/images/success.png" alt="" />
    </div>
    <div class="tip">
      <p>恭喜您已经完成初步审核，点击下一步继续完成申请</p>
    </div>

    <div v-if="this.$route.query.productId === 'WEBANK-YD' && this.isInWechat">
      <wx-open-launch-weapp
        id="launch-btn"
        :username="username"
        :path="path"
        @error="handleErrorFn"
        @launch="handleLaunchFn"
      >
        <script type="text/wxtag-template">
          <style>
            .buttonShellInner {
                box-sizing: border-box;
                height: 44px;
            }
            .btn { height: 50px;
                    line-height: 50px;
                    border: none;
                    font-size: 16px;
                    color: #ffffff;
                    background-color: #ee0a24;
                    width:100%;
                    text-align: center; }</style>
          <div class="buttonShellInner"><button class="btn">下一步</button></div>
        </script>
      </wx-open-launch-weapp>
    </div>
    <!-- 下一步 -->
    <div class="buttonShell" v-else>
      <van-button
        :text="`${!loadingTime ? next :  `${countdown} s`}`"
        :type="danger"
        class="goNext"
        size="large"
        @click="clickNext"
        :loading="this.$store.state.commonForms.Isloading"
        loadingText="提交中..."
      />
    </div>
  </div>
</template>

<script>
/**
 * 进这个页面一定是已经成功了
 */
// @ is an alias to /src
import { Dialog } from 'vant';
import { checkStatus } from './mixin';

export default {
  name: 'GiveTrustWithSum',
  data() {
    return {
      next: '下一步',
      danger: 'danger',
      isInWechat: true,
      username: '',
      path: '',
      countdown: 60,
      loadingTime: false,
    };
  },
  mixins: [checkStatus],
  beforeCreate() {
    document.querySelector('#app').setAttribute('style', 'background-color:#fff');
  },
  created() {
    const { productId } = this.$route.query;
    this.getProductConfig(productId);
    this.isInWechat = this.isWeChat();
    if (productId === 'WEBANK-YD' && this.isInWechat) {
      this.initWXConfig();
    }
  },
  beforeDestroy() {
    document.querySelector('#app').removeAttribute('style');
  },
  computed: {
    Isloading() {
      return this.$store.state.commonForms.Isloading;
    },
  },
  methods: {
    startCountdown() {
      this.loadingTime = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          // eslint-disable-next-line no-plusplus
          this.countdown--;
        } else {
          this.loadingTime = false;
          clearInterval(this.timer);
          // 倒计时结束后的逻辑
        }
      }, 1000); // 每秒减少一秒
    },
    clickNext(){
      const { productId } = this.$route.query;
      this.$api.PublicPage.getProductDetail([productId]).then((res) => {
        if (res.success) {
          if(res.data[0].productCategory=='1'){
            Dialog.confirm({
              title: '信息提示',
              message: `您当前申请的贷款产品需要向第三方主体（即向您提供邀请码的主体或机构）共享在该等金融机构产生的贷款业务相关数据信息（详见授权承诺书中的约定），用于获知该笔申请的授信审批结果之目的。`,
              confirmButtonText: '同意',
              cancelButtonText: '不同意',
            }).then(() => {
              this.jumpTheThirdPartyAddress();
            });
          }else{
            this.jumpTheThirdPartyAddress();
          }
        }
      });
    },
    jumpTheThirdPartyAddress() {
      const { orderId, productId } = this.$route.query;
      if (this.$route.query.productId === 'YL-YPD') {
        if (!this.loadingTime) {
          this.startCountdown();
          if (productId === 'WEBANK-YD') {
            window.location.href = 'https://webankcdn.net/s/hsfs/op-web/easyLoan/index.html?t=7YKGFxEVbQm#/index';
          } else {
            this.$store.dispatch('commonForms/nextJumpPage', {
              orderId: orderId || localStorage.getItem('orderId'),
            });
          }
        } else {
          this.$toast('耐心等待，无需重复点击');
        }
      } else if (productId === 'WEBANK-YD') {
        window.location.href = 'https://webankcdn.net/s/hsfs/op-web/easyLoan/index.html?t=7YKGFxEVbQm#/index';
      } else {
        this.$store.dispatch('commonForms/nextJumpPage', {
          orderId: orderId || localStorage.getItem('orderId'),
        });
      }
    },
    initWXConfig() {
      this.$api.PublicPage.getWXConfig({
        requestUrl: `supermarket${window.location.href.split('supermarket')[1]}`,
      }).then((res) => {
        if (res.success) {
          wx.config({
            debug: false,
            openTagList: ['wx-open-launch-weapp'],
            jsApiList: ['wx-open-launch-weapp'],
            ...res.data,
          });
          wx.ready(() => {
          });
          wx.error((res) => {
            console.log(res);
          });
        }
      });
    },
    handleErrorFn(e) {
      console.log(e.detail);
    },
    handleLaunchFn() {
      console.log('success');
    },
    isWeChat() {
      const ua = window.navigator.userAgent.toLowerCase();
      const isWinxin = ua.indexOf('micromessenger') !== -1;
      if (isWinxin) {
        return true;
      }
      return false;
    },
    getProductConfig(productId) {
      if (productId !== 'WEBANK-YD') return false;
      this.$api.PublicPage.getProductWXConfig({ productId }).then((res) => {
        console.log(res);
        if (res.success) {
          const { path, userName } = res.data;
          this.path = path;
          this.username = userName;
        }
      });
    },
  },
};
</script>
<style scoped>
#launch-btn{
  width: 300px;
}
.topBox {
  width: 100%;
  height: 130px;
}
.mark i {
  color: #f55348;
  font-size: 60px;
}
.mark img {
  width: 60px;
  height: 60px;
}
.warn {
  color: #1c2438;
  font-size: 17px;
  font-size: 700;
  text-align: center;
}
.tip {
  width: 345px;
  height: 60px;
  margin: 0 auto;
  margin-top: 8px;
  color: #9ea7b4;
  font-size: 14px;
  text-align: center;
}
.buttonShell {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding-right: 15px;
  padding-left: 15px;
}
.loadingBox {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
